import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Funciona en cuentas de fondeo?',
  a: 'Sí, es la herramienta ideal para pasar Challenges respetando los límites de pérdida.'
}, {
  q: '¿Es difícil de instalar?',
  a: 'No, te entregamos una guía paso a paso y soporte para que estés operando en minutos.'
}, {
  q: '¿Sirve para otros activos?',
  a: 'Está optimizado para US30, pero funciona en cualquier activo disponible en MT5.'
}, {
  q: '¿Necesito estar pegado al monitor?',
  a: 'El Panel automatiza la ejecución, pero tú decides cuándo activar el sistema.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-dark" data-id="element-44">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="text-center mb-16" data-id="element-46">
          <h2 className="font-display text-3xl font-extrabold text-white uppercase tracking-wide" data-id="element-47">
            Preguntas <span className="text-primary" data-id="element-48">Frecuentes</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-49">
          {faqs.map((faq, index) => <div key={index} className="glass-panel rounded-sm overflow-hidden" data-id="element-50">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none hover:bg-white/5 transition-colors" data-id="element-51">
                <span className="font-display font-medium text-white" data-id="element-52">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-primary transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-53" />
              </button>
              <AnimatePresence data-id="element-54">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-55">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-surfaceHighlight/50 pt-4" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}